<script>
    export default {
        props: ['summercampprop'],
        name: 'SummerCampsSeoCard',
        data() {
            return {
                summer_camp: this.summercampprop,
            }
        },
        computed: {
            showPeriod() {
                if (this.summer_camp) {
                    let date = moment(this.summer_camp.end_date).format('YYYY')
                    return date >= 2021
                }
            },
            detailUrl() {
                return route('summer-camps.show', this.summer_camp.slug)
            },
            companyDetailUrl() {
                return route('company.show', this.summer_camp.company.slug)
            },
            summerCampSlug() {
                return this.summer_camp.slug
            },
            isTheSameMonth() {
                let {start_date,end_date} = this.summer_camp

                if (!_.isEmpty(start_date)) {
                    let startDate = start_date.split('-')
                    let endDate = end_date.split('-')
                    return startDate[1] == endDate[1]
                }
                return false
            },
            isTheSameYear() {
                let {start_date,end_date} = this.summer_camp

                if (!_.isEmpty(start_date)) {
                    let startDate = start_date.split('-')
                    let endDate = end_date.split('-')
                    return startDate[0] == endDate[0]
                }
                return false                
            },
            isPastDate() {
                let endDate = moment(this.summer_camp.end_date);
                return endDate.isBefore(moment());
            }
        },
        methods: {
            dateFormatter(date, format = 'DD/MM/YYYY') {
                return moment(date).format(format);
            },
            getImageBackground() {
                if (this.summer_camp.summer_camp_cover_image && this.summer_camp.summer_camp_cover_image != 'null') {
                    return {
                        'background-image': `url(${this.summer_camp.summer_camp_cover_image})`
                    }
                }
                return {
                    'background-image': `url("${this.summer_camp.summer_camp_image}")`
                }

            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/seo/summer_camps/SummerCampsSeoCard.vue